/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createSystemPermission',
    message: messages.SUCCESS_CREATE_SYSTEM_PERMISSION,
    method: 'POST',
    path: '/system/:systemId/permission',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_SYSTEM_PERMISSION,
    requestSchema: requestSchemas.systemPermissions.createSystemPermission,
  },
  {
    action: 'deleteSystemPermissions',
    message: messages.SUCCESS_DELETE_SYSTEM_PERMISSIONS,
    method: 'DELETE',
    path: '/system/:systemId/permissions',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_SYSTEM_PERMISSION,
    requestSchema: requestSchemas.systemPermissions.deleteSystemPermissions,
  },
  {
    action: 'getSystemPermissions',
    message: messages.SUCCESS_GET_SYSTEM_PERMISSIONS,
    method: 'GET',
    path: '/system/:systemId/permissions',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_SYSTEM_PERMISSION,
    requestSchema: requestSchemas.systemPermissions.getSystemPermissions,
    scopes: [scopes.DEFAULT],
  },
];
